import { render } from "./agree-btn.vue?vue&type=template&id=025f8553&scoped=true"
import script from "./agree-btn.vue?vue&type=script&lang=js"
export * from "./agree-btn.vue?vue&type=script&lang=js"

import "./agree-btn.vue?vue&type=style&index=0&id=025f8553&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025f8553"]])

export default __exports__